import { t } from "@/i18n";

export function getFilterName(type: string) {
    switch (type) {
        case "shape":
            return t("filters.shape");
        case "text":
        case "textV2":
            return t("filters.text");
        case "image":
            return t("filters.image");
        case "sketch":
            return t("filters.pen");
        case "arrow":
            return t("filters.connectorLine");
        case "mindMap":
            return t("filters.mindMap");
        case "sticker":
            return t("filters.sticker");
        case "table":
            return t("filters.table");
        case "card":
            return t("filters.card");
        case "group":
            return t("filters.group");
        case "frame":
            return t("filters.frame");
        case "presentation":
            return t("filters.presentation");
        case "comment":
            return t("filters.comment");
        case "embed":
            return t("filters.embed");
        case "documentViewer":
            return t("filters.document");
        case "emoji":
            return t("filters.emoji");
        case "aiAnswer":
            return t("filters.aiAnswer");
        default:
            return type;
    }
}
